<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="#">
        <img
          class="navbar-brand-full"
          src="img/brand/resi-logo-small-background.png"
          width="89"
          height="25"
          alt="CoreUI Logo"
        />
        <img
          class="navbar-brand-minimized"
          src="img/brand/resi-logo-arrow.png"
          width="30"
          height="30"
          alt="CoreUI Logo"
        />
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" />
      <b-navbar-nav class="d-md-down-none ml-auto">
          <b-nav-item class="d-md-down-none">
          <!-- damage report status link -->
          <div
            v-if="displayLicenseWarning"
            style="margin-right: 1vw"
            class="blink_me"
            @click="TOGGLE_MODAL"
          >
            <i
              class="cil-bell"
              style="font-size: large; margin-right: 0.5vw"
            ></i>
            <span style="font-size: large; color: darkgrey"
              >Lizenz abgelaufen</span
            >
          </div>
        </b-nav-item>
        <b-nav-item class="d-md-down-none">
          <!-- <DefaultHeaderDropdown /> -->
          <b-button type="button" id="logoutBtn" @click="logout">Logout</b-button>
        </b-nav-item>
      </b-navbar-nav>
      <!-- <AsideToggler class="d-none d-lg-block" /> -->
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader />
        <SidebarForm />
        <SidebarNav :navItems="navItems"></SidebarNav>
        <SidebarFooter />
        <SidebarMinimizer />
      </AppSidebar>
      <main class="main">
        <Breadcrumb :list="list" />
        <div class="container-fluid">
           <!-- ADVERTISEMENT image preview overlay -->
          <image-preview
            :toDisplay="getDisplayAdvertisementOverlay"
            :retrieveContent="getAdvertisementOverlayContent"
            :displayError="advertisementOverlayError"
            :retrieveErrorContent="getAdvertisementOverlayErrorContent"
            :filetype="getAdvertisementOverlayFiletype"
          ></image-preview>
          <router-view></router-view>
        </div>
      </main>
      <AppAside fixed>
        <!--aside-->
        <DefaultAside />
      </AppAside>
    </div>
    <TheFooter>
      <!--footer-->
      <div>
        <a href="https://nobugs.marketing">NOBUGS MARKETING GmbH</a>
        <span> | </span>
        <a href="https://nobugs.gmbh">NOBUGS IT GmbH</a>
        <!-- see vuex\store.js for system status -->
        <span>
          | Systemstatus: API: OK / Datenbank: OK / S3: OK / Internet: OK</span
        >
        <!-- <span class="ml-1">&copy; 2020</span> -->
      </div>
      <div class="ml-auto">
        <!-- <span class="mr-1">Powered by</span>
        <a href="https://coreui.io">CoreUI for Vue</a> -->
      </div>
    </TheFooter>
  </div>
</template>

<script>
import nav from "@/_nav";
import {
  Header as AppHeader,
  SidebarToggler,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  Aside as AppAside,
  AsideToggler,
  Footer as TheFooter,
  Breadcrumb,
} from "@coreui/vue";
import DefaultAside from "./DefaultAside";
import DefaultHeaderDropdown from "./DefaultHeaderDropdown";

import ImagePreview from "./ImagePreview";

import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "DefaultContainer",
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdown,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    ImagePreview,
  },
  data() {
    return {
      navItems: nav.items,
    };
  },
  computed: {
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched.filter(
        (route) => route.name || route.meta.label
      );
    },
    ...mapGetters([
      "getDisplayAdvertisementOverlay",
      "getAdvertisementOverlayContent",
      "advertisementOverlayError",
      "getAdvertisementOverlayErrorContent",
      "getAdvertisementOverlayFiletype",
      "licenseExpired",
      "showLicenseWarning"
    ]),
    displayLicenseWarning: function(){
      return this.licenseExpired && this.showLicenseWarning
    }
  },
  methods: {
    ...mapActions(["clearOverlays", "logout"]),
    ...mapMutations(["TOGGLE_MODAL"])
  },
};
</script>

<style scoped>
#logoutBtn {
  margin-right: 1vw;
}

.blink_me {
  animation: blinker 1s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}
</style>
